import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BRANCH } from "constants/AuthConstant";
import ProtectedRoutesService from "services/ProtectedRoutesService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  result: {},
  protectedRoutesList: {},
  getCount: {},
};

export const getProtectedRoutesList = createAsyncThunk(
  "protectedRoutes/getProtectedRoutesList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProtectedRoutesService.getProtectedRoutes(data);
      if (response.status === 2001 || response.status === 200) {
        console.log("cek response protected routes: ", response);
        if (response.data != null) {
          notification.success({
            message: "Success",
            description: "Get item success",
            duration: 1,
          });
        } else {
          notification.error({
            message: "Error",
            description: "Error response!!",
            duration: 1,
          });
        }
        return response || "No Response";
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 1,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 1,
      });
      return rejectWithValue(error.response?.data.message || "Catched error!");
    }
  }
);

export const ProtectedRoutesSlice = createSlice({
  name: "protectedRoutes",
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = "/";
      localStorage.setItem(BRANCH, JSON.stringify(action.payload));
      // state.selectedBranch = action.payload;
    },
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      //get list branch
      .addCase(getProtectedRoutesList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProtectedRoutesList.fulfilled, (state, action) => {
        state.loading = false;
        state.protectedRoutesList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getProtectedRoutesList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, showLoading, authenticated } =
  ProtectedRoutesSlice.actions;

export default ProtectedRoutesSlice.reducer;
